// The city picker's regions and what its search finds (site/js/app.js): a city by its name, its country (or a name people
// often type for it, such as USA or UK) or its region, from the registry's country and region. And how much room the
// picker needs over the dock (pickerOverDock).
export const REGIONS = ['Europe', 'Americas', 'Asia', 'Africa', 'Oceania'];   // the chips' order (the UN's continents)
const AKA = {
  'United States': ['usa', 'us', 'america'],
  'United Kingdom': ['uk', 'britain', 'great britain', 'england'],
  'United Arab Emirates': ['uae', 'emirates'],
  Netherlands: ['holland'],
  Czechia: ['czech republic'],
  Turkey: ['turkiye'],
  'Hong Kong SAR': ['china'],
};

export const fold = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();   // "sao" finds "São"

/** The regions the cities are in, in REGIONS order, with how many each: [{ region, count }] */
export const regionsOf = scenes => REGIONS.map(region => ({ region, count: scenes.filter(s => s.region === region).length })).filter(r => r.count);

/**
 * A search (folded) finds a city when its name has it anywhere, or a word of its country or region starts with it, or
 * one of its country's other names does ("ger" finds Hamburg and Munich, "usa" New York and San Francisco).
 */
export function cityMatches(scene, q) {
  if (!q || fold(scene.name).includes(q)) return true;
  const words = [scene.country, scene.region].flatMap(t => fold(t ?? '').split(/\s+/));
  const phrases = [fold(scene.country ?? ''), fold(scene.region ?? ''), ...(AKA[scene.country] ?? [])];
  return words.some(w => w.startsWith(q)) || phrases.some(p => p.startsWith(q));
}

/**
 * The picker opens above the dock: from the title's top edge (`top`, CSS px down the page) to 8 px over the dock's
 * (`dockTop`). Under PICKER_ROOM there (a phone on its side, a keyboard that shortens the page) its head, search and
 * chips (124 px on a phone) leave too little for a row of cards (up to 150 px) or for the smallest globe and its hint
 * (163 px), so it opens over the dock instead (site/css/app.css .over-dock).
 */
export const PICKER_ROOM = 300;
export const pickerOverDock = (top, dockTop) => dockTop - 8 - top < PICKER_ROOM;
